/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ForaeldreloestAfregningsgrundlagDto as OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto } from '../models/OK/Egis/Service/Models/DTO/foraeldreloest-afregningsgrundlag-dto';
import { ForaeldreloestAfregningsgrundlagUpdateDto as OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagUpdateDto } from '../models/OK/Egis/Service/Models/DTO/foraeldreloest-afregningsgrundlag-update-dto';
import { PartnerCreatedOrdreRejectionDto as OkEgisServiceModelsDtoPartnerCreatedOrdreRejectionDto } from '../models/OK/Egis/Service/Models/DTO/partner-created-ordre-rejection-dto';
import { GetForaldreloeseRequest as OkEgisServiceModelsRequestGetForaldreloeseRequest } from '../models/OK/Egis/Service/Models/Request/get-foraldreloese-request';
import { GetForaledreloeseResponse as OkEgisServiceModelsResponseGetForaledreloeseResponse } from '../models/OK/Egis/Service/Models/Response/get-foraledreloese-response';

@Injectable({
  providedIn: 'root',
})
export class ForaeldreloestAfregningsgrundlagService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getForaldreloese
   */
  static readonly GetForaldreloesePath = '/api/v1/ForaeldreloestAfregningsgrundlag/GetForaldreloese';

  /**
   * Gets all active ForaeldreloestAfregningsgrundlag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getForaldreloese()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getForaldreloese$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetForaldreloeseRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetForaledreloeseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ForaeldreloestAfregningsgrundlagService.GetForaldreloesePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetForaledreloeseResponse>;
      })
    );
  }

  /**
   * Gets all active ForaeldreloestAfregningsgrundlag.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getForaldreloese$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getForaldreloese(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetForaldreloeseRequest
  }): Observable<OkEgisServiceModelsResponseGetForaledreloeseResponse> {

    return this.getForaldreloese$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetForaledreloeseResponse>) => r.body as OkEgisServiceModelsResponseGetForaledreloeseResponse)
    );
  }

  /**
   * Path part for operation getById
   */
  static readonly GetByIdPath = '/api/v1/ForaeldreloestAfregningsgrundlag/GetById';

  /**
   * Gets all active ForaeldreloestAfregningsgrundlag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getById$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto>> {

    const rb = new RequestBuilder(this.rootUrl, ForaeldreloestAfregningsgrundlagService.GetByIdPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto>;
      })
    );
  }

  /**
   * Gets all active ForaeldreloestAfregningsgrundlag.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getById(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto> {

    return this.getById$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto>) => r.body as OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto)
    );
  }

  /**
   * Path part for operation updateForaeldreloestAfregningsgrundlag
   */
  static readonly UpdateForaeldreloestAfregningsgrundlagPath = '/api/v1/ForaeldreloestAfregningsgrundlag/UpdateForaeldreloestAfregningsgrundlag';

  /**
   * Updates a single ForaeldreloestAfregningsgrundlag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateForaeldreloestAfregningsgrundlag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateForaeldreloestAfregningsgrundlag$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto>> {

    const rb = new RequestBuilder(this.rootUrl, ForaeldreloestAfregningsgrundlagService.UpdateForaeldreloestAfregningsgrundlagPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto>;
      })
    );
  }

  /**
   * Updates a single ForaeldreloestAfregningsgrundlag.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateForaeldreloestAfregningsgrundlag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateForaeldreloestAfregningsgrundlag(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagUpdateDto
  }): Observable<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto> {

    return this.updateForaeldreloestAfregningsgrundlag$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto>) => r.body as OkEgisServiceModelsDtoForaeldreloestAfregningsgrundlagDto)
    );
  }

  /**
   * Path part for operation rejectPartnerCreatedOrder
   */
  static readonly RejectPartnerCreatedOrderPath = '/api/v1/ForaeldreloestAfregningsgrundlag/RejectPartnerCreatedOrder';

  /**
   * Afviser en partneroprettet ordre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectPartnerCreatedOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rejectPartnerCreatedOrder$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Dto containing remark and id
     */
    body?: OkEgisServiceModelsDtoPartnerCreatedOrdreRejectionDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ForaeldreloestAfregningsgrundlagService.RejectPartnerCreatedOrderPath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Afviser en partneroprettet ordre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rejectPartnerCreatedOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rejectPartnerCreatedOrder(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Dto containing remark and id
     */
    body?: OkEgisServiceModelsDtoPartnerCreatedOrdreRejectionDto
  }): Observable<void> {

    return this.rejectPartnerCreatedOrder$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
